import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Abcom\\Documents\\salman\\edviseme\\website_cara\\src\\components\\common\\Footer.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Abcom\\Documents\\salman\\edviseme\\website_cara\\src\\components\\common\\Header.jsx");
